export type GenufitMarkTone = 'light' | 'dark'

/** Locked Round 11 mirrored rasters — HIR-84 placement board (HIR-176). */
export const GENUFIT_MARK_PNG = {
  light: {
    auth: '/concept-a-bullseye-brand-light-mirrored-256.png',
    sidebar: '/concept-a-bullseye-brand-light-mirrored-40.png',
  },
  dark: {
    auth: '/concept-a-bullseye-brand-on-dark-parity-256.png',
    sidebar: '/concept-a-bullseye-brand-on-dark-parity-40.png',
  },
} as const

export type GenufitMarkPlacement = 'auth' | 'sidebar'

export function genufitMarkPngSrc(
  placement: GenufitMarkPlacement,
  tone: GenufitMarkTone,
  size: number,
): string {
  const assets = GENUFIT_MARK_PNG[tone]
  if (placement === 'auth') {
    return assets.auth
  }
  return size > 40 ? assets.auth : assets.sidebar
}
